"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)(_components.Dialog, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isInfo', 'zIndex'])
})`
  z-index: ${({
  zIndex
}) => zIndex};

  button {
    z-index: ${({
  zIndex
}) => typeof zIndex === 'number' ? zIndex + 1 : undefined};
  }

  & .${_components.dialogClasses.closeButton} {
    z-index: 10;
  }

  & .${_mui.paperClasses.root} {
    ${({
  theme
}) => theme.breakpoints.up('sm')} {
      width: ${props => props.isInfo ? '390px' : '720px'};
      max-width: 95vw;
    }

    ${({
  theme
}) => theme.breakpoints.up('md')} {
      height: ${props => props.isInfo ? 'auto' : '450px'};
      overflow: visible;
      width: ${props => props.isInfo ? '390px' : '900px'};
      max-width: 80vw;
    }

    ${({
  theme
}) => theme.breakpoints.up('lg')} {
      max-width: 75vw;
    }
  }
`;